import type { ActivityItem } from '../types';

const EMOJI_MAP: Record<string, string> = {
  heart: '\u2764\uFE0F',
  laugh: '\uD83D\uDE02',
  wow: '\uD83D\uDE2E',
  sad: '\uD83D\uDE22',
  fire: '\uD83D\uDD25',
};

export function getActivityText(activity: ActivityItem): string {
  const count = activity.count;
  switch (activity.type) {
    case 'photo_uploaded':
      if (activity.metadata?.type === 'video') {
        return count > 1 ? `uploaded ${count} videos` : 'uploaded a video';
      }
      return count > 1 ? `uploaded ${count} photos` : 'uploaded a photo';
    case 'comment_added':
      return count > 1 ? `added ${count} comments` : 'commented';
    case 'reaction_added': {
      const emoji = activity.metadata?.emoji;
      if (count > 1) return `reacted ${count} times`;
      return `reacted ${emoji ? EMOJI_MAP[emoji] || emoji : ''}`;
    }
    case 'photo_loved':
      if (activity.metadata?.mediaType === 'video') {
        return count > 1 ? `loved ${count} videos` : 'loved a video';
      }
      return count > 1 ? `loved ${count} photos` : 'loved a photo';
    case 'member_joined':
      return 'joined the family';
    default:
      return activity.type;
  }
}
